// src/Components/AIMito/Suggestions.tsx
import React, { useState } from 'react';
import { QBOIcon } from 'assets/icons';
import QuickbooksModal, { QB_SUGGESTIONS } from './QuickbooksModal';

interface SuggestionsProps {
  suggestions: string[];
  onClick: (suggestion: string) => void;
}

const Suggestions: React.FC<SuggestionsProps> = ({ suggestions, onClick }) => {
  const [showQBModal, setShowQBModal] = useState(false);

  const filtered = suggestions.filter(
    (s) => !QB_SUGGESTIONS.includes(s.toLowerCase()),
  );

  return (
    <div className="suggestions">
      {filtered.map((suggestion, index) => (
        <button
          key={index}
          className="suggestion-btn"
          onClick={() => onClick(suggestion)}
        >
          {suggestion}
        </button>
      ))}

      <button
        type="button"
        className="suggestion-btn suggestion-qb"
        onClick={() => setShowQBModal(true)}
      >
        {'QBO'} <QBOIcon className="suggestion-qb-icon" />
      </button>

      {showQBModal && (
        <QuickbooksModal
          onSelect={onClick}
          onClose={() => setShowQBModal(false)}
        />
      )}
    </div>
  );
};

export default Suggestions;
